<template>
  <div class="msgCenter">
    <div class="newsDetial-header">
      <div class="newsDetial-title">消息中心</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">请快速解决收到消息的问题。</div>
      <blank height="45"> </blank>
    </div>

    <div class="msgCenter-cont">
      <div class="newsLsit-header">
        <a-tabs v-model="tabnum" @change="tabClick">
          <a-tab-pane key="1" tab="任务通知" />
          <a-tab-pane key="2" tab="表单通知" />
          <a-tab-pane key="3" tab="系统通知" />
        </a-tabs>
      </div>
      <a-empty v-show="data.length === 0 ? true : false" />
      <div class="msgCenter-item" v-for="(i, index) in data" :key="index">
        <div class="msgCenter-item-top">
          <img src="./img/infoLogo.png" alt="" />
          <div class="msg-title">{{ i.msgTitle }}</div>
        </div>
        <div class="msg-cont">
          {{ i.msgContent }}
        </div>
      </div>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
import { msgInfoList } from '@/views/workbench/api/api'
export default {
  data() {
    return {
      data: [],
      total: 0,
      page: 1,
      size: 10,
      loading: false,
      tabnum: '1'
    }
  },
  created() {
    this.load()
  },
  methods: {
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    tabClick(key) {
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      let params = {}
      params.msgType = this.tabnum
      params.page = this.page
      params.size = this.size
      msgInfoList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.msgCenter {
  .newsDetial-header {
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
  }
  .msgCenter-cont {
    background: #fff;
    margin: 24px 16px;
    padding: 30px 80px 20px 80px;
    .msgCenter-item {
      // height: 80px;
      padding: 10px 0;
      border-bottom: #e9e9e9 1px solid;
      .msgCenter-item-top {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 32px;
          height: 32px;
          border-radius: 16px;
        }
        .msg-title {
          margin-left: 16px;
          height: 28px;
          color: rgba(56, 56, 56, 1);
          font-size: 14px;
          line-height: 28px;
          text-align: left;
        }
      }
      .msg-cont {
        padding-left: 48px;
        color: rgba(128, 128, 128, 1);
        font-size: 14px;
        // line-height: 28px;
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/workbench/messageCenter.vue